import { BaseService, BaseServiceConstructor } from 'api/services/base.service';
import {
  TempTableUploadErrorResponse,
  TempTableUploadStatus,
} from 'types/responses/TempTableUploadStatus';

export class ImportService extends BaseService {
  public baseUrl: string;

  constructor({ serviceUrls, token, tenantName }: BaseServiceConstructor) {
    super({ serviceUrls, token, tenantName });
    this.baseUrl = serviceUrls.dataImporterUrl;
  }

  async getTempTableUploadStatus(
    append: boolean
  ): Promise<TempTableUploadStatus | TempTableUploadErrorResponse> {
    const { data } = await this.dataImporterHttpClient.get<
      TempTableUploadStatus | TempTableUploadErrorResponse
    >(`/inventory/import/${this.tenantName}/upload/status`, {
      withCredentials: false,
      params: {
        append,
      },
    });
    return data;
  }

  async postTempTableUpload(
    geoDbFile: File,
    wsConnectionId: string,
    append: boolean
  ): Promise<void> {
    const requestBody = new FormData();
    requestBody.append('file', geoDbFile);
    await this.dataImporterHttpClient.post(
      `/inventory/import/${this.tenantName}/upload`,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/octet-stream',
          Accept: 'application/json',
        },
        withCredentials: false,
        params: {
          wsConnectionId,
          append,
        },
      }
    );
  }

  async validateTempTables(wsConnectionId: string, append: boolean): Promise<void> {
    await this.dataImporterHttpClient.get(`/inventory/import/${this.tenantName}/validate/upload`, {
      params: {
        wsConnectionId,
        append,
      },
      withCredentials: false,
    });
  }

  async populateTempTablesToDatabase(wsConnectionId: string, append: boolean): Promise<void> {
    await this.dataImporterHttpClient.post(
      `/inventory/import/${this.tenantName}/populate/upload`,
      {},
      {
        withCredentials: false,
        params: {
          wsConnectionId,
          append,
        },
      }
    );
  }

  async updateComputedValuesService(): Promise<string> {
    const { data }: { data: string } = await this.dataImporterHttpClient.post(
      `/inventory/import/${this.tenantName}/populate/computedValues`,
      {
        withCredentials: false,
      }
    );

    return data;
  }

  async cancelTempTableImport(wsConnectionId: string): Promise<void> {
    await this.dataImporterHttpClient.delete(
      `/inventory/import/${this.tenantName}/cancel`,
      {
        params: {
          wsConnectionId,
        },
      },
      {
        withCredentials: false,
      }
    );
  }
}
